const HeaderSearch = () => {

    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        const searchIcon = document.querySelector('.header__icon--search');
        const searchHeader = document.getElementById('header-search');
        const closeSearchHeaderBtn = document.getElementById('close-search');

        // Function to open the popup
        function openSearch() {
            searchHeader.classList.add('active');
            //overlay.classList.add('active');
        }

        // Function to close the popup
        function closeSearchHeader() {
            searchHeader.classList.remove('active');
            //overlay.classList.remove('active');
        }

        // Event listener to open when icon is clicked
        searchIcon.addEventListener('click', openSearch);

        // Event listener to close when close button is clicked
        closeSearchHeaderBtn.addEventListener('click', closeSearchHeader);

        // Close when pressing the Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && searchHeader.classList.contains('active')) {
                closeSearchHeader();
            }
        });
    });
}

export default HeaderSearch;
